<template>
	<div class="guide-page">
		<div class="logo-box">
			<img class="logo" :src="img.logo" alt="凌志范儿">
		</div>
		<div class="qr-list">
			<div class="qr-row qr-row-three">
				<div class="qr-cell">
					<div class="qr-launch">
						<img class="qr-img" :src="img.shipinhao" alt="视频号">
						<wx-open-launch-weapp class="qr-launch-btn" appid="wx8225e89a5d5ed169"
							username="gh_d2c493f1bc41"
							path="pages/transit/transit?finderUserName=sphkGG3ge9coPii&name=凌志范儿" @launch="openWeChat"
							@error="onLaunchError">
							<script type="text/wxtag-template">
								<style>
								          .btn {
								            position: absolute;
								            inset: 0;
											top:0;
											left:0;
								            width: 100%;
								            height: 100%;
								            background: transparent;
								            border: 0;
								            padding: 0;
								            cursor: pointer;
								          }
								        </style>
								        <button class="btn" aria-label="打开小程序"></button>
						</script>
						</wx-open-launch-weapp>
					</div>
					<div class="qr-label" style="font-size: 9px;">点击进入<span class="f-w">凌志范儿视频号</span></div>
				</div>
				<div class="qr-cell">
					<div class="qr-launch">
						<img class="qr-img" :src="img.xiaochengxu" alt="小程序">
						<wx-open-launch-weapp class="qr-launch-btn" appid="wx8225e89a5d5ed169"
							username="gh_d2c493f1bc41" path="pages/index/index" @launch="openWeChat"
							@error="onLaunchError">
							<script type="text/wxtag-template">
								<style>
								          .btn {
								            position: absolute;
								            inset: 0;
											top:0;
											left:0;
								            width: 100%;
								            height: 100%;
								            background: transparent;
								            border: 0;
								            padding: 0;
								            cursor: pointer;
								          }
								        </style>
								        <button class="btn" aria-label="打开小程序"></button>
							</script>
						</wx-open-launch-weapp>
					</div>
					<div class="qr-label" style="font-size: 9px;">点击进入<span class="f-w">凌志范儿小程序</span></div>
				</div>
				<div class="qr-cell">
					<img class="qr-img" :src="img.xiaohongshu" alt="小红书" @click="openXiaohongshu">
					<div class="qr-label" style="font-size: 9px;">点击进入<span class="f-w">凌志范儿小红书</span></div>
				</div>
			</div>
			<div class="qr-row qr-row-two">
				<div class="qr-cell">
					<img class="qr-img qr-img-recognize" :src="img.gongzhonghao" alt="公众号" @click="showBig('凌志范儿公众号')"
						@touchstart="onQrTouchStart($event, '凌志范儿公众号')" @touchmove="onQrTouchMove"
						@touchend="onQrTouchEnd" @touchcancel="onQrTouchEnd" @contextmenu="onQrContextMenu('凌志范儿公众号')">
					<div class="qr-label">扫码进入<span class="f-w">凌志范儿公众号</span></div>
				</div>
				<div class="qr-cell">
					<img class="qr-img qr-img-recognize" :src="img.kefu" alt="凌志范儿客服" @click="showBig('凌志范儿客服')"
						@touchstart="onQrTouchStart($event, '凌志范儿客服')" @touchmove="onQrTouchMove"
						@touchend="onQrTouchEnd" @touchcancel="onQrTouchEnd" @contextmenu="onQrContextMenu('凌志范儿客服')">
					<div class="qr-label">扫码添加<span class="f-w">凌志范儿客服</span></div>
				</div>
			</div>
		</div>

		<van-image-preview v-model="showPreview" :images="previewImages" :start-position="previewIndex"
			closeable></van-image-preview>
	</div>
</template>

<script>
	import content from '../../api/content';
	import wxShare from '../../api/wxShare';
	import common from '../../api/common';
	export default {
		data() {
			return {
				img: {
					logo: require('../../assets/img/lexus/guidepage/logo.png'),
					shipinhao: require('../../assets/img/lexus/guidepage/sph.png'),
					xiaochengxu: require('../../assets/img/lexus/guidepage/xcx.png'),
					xiaohongshu: require('../../assets/img/lexus/guidepage/xhs.png'),
					gongzhonghao: require('../../assets/img/lexus/guidepage/gzh.png'),
					kefu: require('../../assets/img/lexus/guidepage/kf.png')
				},
				showPreview: false,
				previewImages: [],
				previewIndex: 0,
				longPressFlag: false,
				longPressTimer: null,
				xiaohongshuUrl: 'https://www.xiaohongshu.com/user/profile/6321785f0000000023024895?xhsshare=userQrCode'
			}
		},
		created() {
			this.initWxConfig()
			var params = {
				event_code: '凌志范儿 · 聚合主页',
				event_id: '',
				title: '',
				value: '',
				path: '/Lexus/guidePage.vue',
				user_id: '',
				source: '',
				source_page: '凌志范儿 · 聚合主页-打开首页'
			}
			this.BurialPoint(params)
		},
		methods: {
			BurialPoint(params) {
				common.BurialPoint(params).then(res => {
					if (res.data.state == 1) {

					}
				})
			},
			initWxConfig() {
				const url = window.location.href.split('#')[0]
				content.getShare({
					url
				}).then(res => {
					if (res.data.state == 1) {
						wxShare.getJSSDK(res.data.data, {
							'title': '凌志范儿',
							'description': '',
							'share_image': 'https://pic.motortime.com/static/lexus_uni/logo.png'
						})
					}
				})
			},
			openXiaohongshu() {
				window.open(this.xiaohongshuUrl)
				var params = {
					event_code: '凌志范儿 · 聚合主页',
					event_id: '',
					title: '',
					value: '',
					path: '/Lexus/guidePage.vue',
					user_id: '',
					source: '',
					source_page: '凌志范儿 · 聚合主页-打开小红书'
				}
				this.BurialPoint(params)
			},
			openWeChat() {
				console.log('打开小程序成功')
				var params = {
					event_code: '凌志范儿 · 聚合主页',
					event_id: '',
					title: '',
					value: '',
					path: '/Lexus/guidePage.vue',
					user_id: '',
					source: '',
					source_page: '凌志范儿 · 聚合主页-打开小程序成功'
				}
				this.BurialPoint(params)
			},
			onLaunchError(e) {
				const detail = e.detail || {}
				const msg = (detail.errMsg || '打开小程序失败') + (detail.errCode ? ' (' + detail.errCode + ')' : '')
				this.$toast(msg)
				console.log('打开小程序失败', detail)
			},
			showBig(type) {
				if (this.longPressFlag) {
					this.longPressFlag = false
					return
				}
				if (type === '凌志范儿公众号') {
					this.previewImages = [this.img.gongzhonghao]
				} else if (type === '凌志范儿客服') {
					this.previewImages = [this.img.kefu]
				}
				this.previewIndex = 0
				this.showPreview = true
				var params = {
					event_code: '凌志范儿 · 聚合主页',
					event_id: '',
					title: '',
					value: '',
					path: '/Lexus/guidePage.vue',
					user_id: '',
					source: '',
					source_page: '凌志范儿 · 聚合主页-查看' + type + '二维码'
				}
				this.BurialPoint(params)
			},
			onQrTouchStart(e, type) {
				this.longPressFlag = false
				clearTimeout(this.longPressTimer)
				this.longPressTimer = setTimeout(() => {
					this.longPressFlag = true
					this.recordRecognize(type)
				}, 600)
			},
			onQrTouchMove() {
				clearTimeout(this.longPressTimer)
				this.longPressTimer = null
			},
			onQrTouchEnd() {
				clearTimeout(this.longPressTimer)
				this.longPressTimer = null
			},
			onQrContextMenu(type) {
				this.longPressFlag = true
				this.recordRecognize(type)
			},
			recordRecognize(type) {
				var params = {
					event_code: '凌志范儿 · 聚合主页',
					event_id: '',
					title: '',
					value: '',
					path: '/Lexus/guidePage.vue',
					user_id: '',
					source: '',
					source_page: '凌志范儿 · 聚合主页-识别' + type + '二维码'
				}
				this.BurialPoint(params)
			}
		}
	};
</script>

<style lang="scss" scoped>
	.guide-page {
		height: 100vh;
		background: #ffffff;
		overflow: hidden;

		// logo.png 为 1920×1920 且四周透明，内容区约 892×871；按 375 设计稿缩放到内容约 173×169
		.logo-box {
			position: relative;
			width: 173px;
			height: 169px;
			margin: 88px auto 0;
			overflow: hidden;

			.logo {
				position: absolute;
				top: -87px;
				left: -100px;
				width: 372px;
				height: 372px;
				max-width: none;
			}
		}


		.open_btn {
			width: 200px;
			height: 45px;
			text-align: center;
			font-size: 17px;
			display: block;
			margin: 10px auto;
			padding: 8px 24px;
			border: none;
			border-radius: 4px;
			background-color: #07c160;
			position: relative;
			color: #ffffff;
		}

		.qr-list {
			margin-top: 50px;
			padding: 0 20px;
		}

		.qr-row {
			display: flex;
			align-items: flex-start;
			justify-content: space-between;
			margin-bottom: 20px;
		}

		.qr-row-three {
			.qr-cell {
				width: 30%;
			}
		}

		.qr-row-two {
			justify-content: center;

			.qr-cell {
				width: 40%;
				margin: 0 15px;
			}
		}

		.qr-cell {
			display: flex;
			flex-direction: column;
			align-items: center;
		}

		.qr-launch {
			position: relative;
			width: 100%;
		}

		.qr-launch-btn {
			position: absolute;
			top: 0;
			left: 0;
			width: 100%;
			height: 100%;
			display: block;
			z-index: 1001;
		}

		.qr-img {
			width: 100%;
			height: auto;
			display: block;
			border-radius: 12px;
		}

		.qr-img-recognize {
			-webkit-touch-callout: default;
			-webkit-user-select: auto;
			user-select: auto;
		}

		.qr-label {
			margin-top: 12px;
			font-size: 10px;
			color: #333333;
			text-align: center;
		}
	}
</style>